
import { AD_LAYOUT_STUBS } from "@consts";
import { getCrosswordAnswers } from "@/common/services/crosswordSolverService";
import scrollTriggeredModalMixin from "@/plugins/mixins/scroll-triggered-modal";

export default {
	name: "CrosswordSolver",
	mixins: [scrollTriggeredModalMixin],
	data() {
		return {
			results: null,
			AD_LAYOUT_STUBS,
			isLoading: false,
		};
	},
	computed: {
		resultCountText() {
			return `${this.results.length} word${
				this.results.length > 1 ? "s" : ""
			}`;
		},
		searchIsDirty() {
			return this.results !== null;
		},
	},
	destroyed() {
		this.setHtmlSmoothScroll(false);
	},
	methods: {
		setHtmlSmoothScroll(value) {
			const classList = document?.documentElement?.classList;
			const className = "smooth-scroll";

			if (!classList) {
				return;
			}

			if (value === true) {
				classList.add(className);
			} else {
				classList.remove(className);
			}
		},
		async onFormSubmit(params) {
			this.isLoading = true;
			const items = await getCrosswordAnswers(
				this.$axios,
				this.$config,
				params
			);

			this.results = items.map((w) => w.toUpperCase());
			this.isLoading = false;

			if (!this.isExtraLargeDevice) {
				this.setHtmlSmoothScroll(true);
				document
					.querySelector("label[for='known_letters']")
					?.scrollIntoView();
			}
		},
	},
};
